<template>
        
        <v-container  >
                 <!-- <div id="mySidenav" class="sidenav" v-show="showBack">
                            <div @click="showOption=true,showPageBeginner=false,showPageAdvanced=false, showPageIntermediate=false,showBack=false" class="box1" color="red">  
                                    <v-icon  large color="white"> mdi-home </v-icon> Home

                            </div>
                    </div> -->

                <div class="mt-1 ml-5 text-lg-body-2"  v-show="showBack">
                               <a @click="showOption=true,showPageBeginner=false,showPageAdvanced=false, showPageIntermediate=false,showBack=false">  
                                  <v-icon small color="grey"> mdi-arrow-left </v-icon> <span class="grey--text font-weight-medium"> BACK </span>

                            </a>
                </div>
        <div v-show="showOption" class="mt-n1 pb-0">
            <v-layout row justify-center > 
                    <v-flex  md6 mt-10 pt-3 >
                            
                                    <p class="text-h3 text-md-h4 text-center monsterrat font-weight-medium"> <span> Level Test </span> </p>
                            
                    </v-flex>
            </v-layout>

           <v-layout>

                     <v-flex xs12 lg12 md6>
                                
                                <v-col>  <p> <span class="font-weight-bold"> 1. Introduction </span></p> 
                                
                                  <v-card class="px-2 py-lg-6 pb-lg-7 py-md-10 py-10 elevation-0 rounded-xl" color="rgb(234, 244, 250)">

                                    <v-list-item>

                                                      <v-list-item-content>
                                                        <span> Please answer the following questions.</span>
                                                      </v-list-item-content>
                                          
                                    </v-list-item>

                                    <v-list-item>
                                            <v-flex xs12 lg12 md12>
                                                  <v-card class="white px-5 py-5 elevation-0">
                                                    <p >
                                                        1. What is your name?

                                                    </p>
                                                    <p >
                                                        2. How old are you?

                                                    </p>
                                                    <p >
                                                        3. Where do you live?

                                                    </p>
                                                    <p >
                                                       4. What are your hobbies?

                                                    </p>
                                                  </v-card>
                                            </v-flex>
                                    </v-list-item>
                                    </v-card>
                              </v-col>
                              
                            </v-flex>
        
            </v-layout>
        
            <v-layout>

                    <v-flex lg12 md12 xs12 class="font-italic text-lg-body-1 text-subtitle-2"> Choose the appropriate level based on the student’s response. </v-flex>

            </v-layout>

           <a @click="showPageBeginner=true,showPageAdvanced=false, showPageIntermediate=false,showOption=false,showBack=true" class="black--text">
                <v-layout row justify-center> 
                
                        <v-flex xs11 lg11 md6 mt-6 pt-3 class="beginner-color" rounded-lg>
                                
                                        <p class="text-h6 text-md-h4 text-center monsterrat"> <span> Beginner  </span> </p>
                                
                        </v-flex>
                    
                </v-layout>
            </a>

            


            <a @click="showPageBeginner=false,showPageAdvanced=false, showPageIntermediate=true,showOption=false,showBack=true" class="black--text">
                <v-layout row justify-center> 
                        <v-flex xs11 lg11 md6 mt-6 pt-3 class="intermediate-color" rounded-lg>
                                
                                        <p class="text-h6 text-md-h4 text-center monsterrat"> <span> Intermediate </span> </p>
                                
                        </v-flex>
                </v-layout>
            </a>
            <a @click="showPageBeginner=false,showPageAdvanced=true, showPageIntermediate=false,showOption=false,showBack=true" class="black--text">
                <v-layout row justify-center > 
                        <v-flex xs11 lg11 md6 mt-6 pt-3 class="advanced-color" rounded-lg>
                                
                                        <p class="text-h6 text-md-h4 text-center monsterrat"> Advanced </p>
                                
                        </v-flex>
                </v-layout>
            </a>

        </div>
        <div class="mt-n2">

                       <div v-show="showPageBeginner">
                                        <beginner  />
                      
                        </div>

                        <div v-show="showPageAdvanced">
                                        <advanced  />
                      
                        </div>

                         <div v-show="showPageIntermediate">
                                        <intermediate />
                      
                        </div>
        </div>

                        <div class="mt-1 ml-5 text-lg-body-2"  v-show="showBack">
                               <a @click="showOption=true,showPageBeginner=false,showPageAdvanced=false, showPageIntermediate=false,showBack=false">  
                                  <v-icon  small color="grey"> mdi-arrow-left </v-icon> <span class="grey--text font-weight-medium"> BACK </span>

                            </a>
                </div>
                        
        </v-container>

    
</template>
<script>
import beginner from './levels/beginner.vue'
import advanced from './levels/advanced.vue'
import intermediate from './levels/intermediate.vue'
export default {
    name:'Home',
    components: {
            beginner,
            advanced,
            intermediate
    },
    data:()=> {
            return {
                  showPageBeginner:false,
                  showPageAdvanced:false,
                  showPageIntermediate:false,
                  showOption:true,
                  showBack:false,
            }
    },
}
</script>
<style scoped>
.monsterrat {
    font-family: 'Montserrat', serif !important;
}
</style>